  <!-- Navbar removed -->


<!-- Router Outlet -->
<div class="content">
  <ng-container>
    <router-outlet></router-outlet>
  </ng-container>
</div>
